module.exports = __webpack_public_path__ + "static/media/my_photos.635931ac.svg";